import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import ValueEditorRenderer from './ValueEditorRenderer/ValueEditorRenderer'
import { displayMatchTypes } from './constants'
import * as Styles from './styles'

const MatchTypeEditor = ({
  matchType,
  field,
  matchTypeOptions,
  onChangeMatchType,
  value,
  onChange,
  matchCase,
  onChangeMatchCase,
  disabled,
  showCombo,
  comboItems,
  hierarchical,
  hasError,
  matchTypeError,
  inputBackgroundColor,
  matchCurrency,
  onChangeMatchCurrency,
  currencies,
  storeCurrencyCode,
  selectableCurrency,
}) => {
  const { t } = useTranslation()

  const isBoolean = matchType === displayMatchTypes.boolean

  return (
    <Styles.Container>
      {!isBoolean && (
        <ComboBox
          label={t('Tipo de coincidencia')}
          menuItems={matchTypeOptions}
          handleChange={e => onChangeMatchType(e.target.value)}
          value={matchType || ''}
          fullWidth
          disabled={disabled}
          error={matchTypeError}
          helperText={matchTypeError ? t('Este campo es obligatorio') : ' '}
          backgroundColor={inputBackgroundColor}
        />
      )}
      <ValueEditorRenderer
        matchType={matchType}
        field={field}
        value={value}
        onChange={onChange}
        matchCase={matchCase}
        onChangeMatchCase={onChangeMatchCase}
        disabled={disabled}
        showCombo={showCombo}
        comboItems={comboItems}
        hierarchical={hierarchical}
        hasError={hasError}
        inputBackgroundColor={inputBackgroundColor}
        matchCurrency={matchCurrency}
        onChangeMatchCurrency={onChangeMatchCurrency}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        selectableCurrency={selectableCurrency}
      />
    </Styles.Container>
  )
}

export default MatchTypeEditor
